import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useEffect } from 'react';
import './Test.css';

import { calculateResults, getResult, saveResults } from '../calculate_results';
import { tests, answers } from './questions';

export default function Test() {
    const navigate = useNavigate();
    const [testIndex, setTestIndex] = useState(0);
    const [selected, setSelected] = useState([]);

    const test = tests[testIndex];
    const answered = selected.filter(answer => answer != null).length;

    useEffect(() => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    }, [testIndex]);

    const handleSubmit = () => {
        if (answered !== test.questions.length) return;

        saveResults(
            test.key,
            getResult(calculateResults(selected))
        );

        if (testIndex < tests.length - 1) {
            setTestIndex(prev => prev + 1);
            setSelected([]);
        } else {
            navigate('/results');
        }
    };

    return (
        <section className="test">
            <header className="test__header">
                <span>{test.header}</span>
                <span>{answered} / {test.questions.length}</span>
            </header>

            <h1 className="test__title">
                {test.title}<br />
                <em>{test.subtitle}</em>
            </h1>

            <p className="test__description">{test.description}</p>

            <div className="test__questions">
                {test.questions.map((question, i) => (
                    <article className="test__question" key={i}>
                        <div className="test__number">
                            {String(i + 1).padStart(2, '0')}
                        </div>

                        <p>{question}</p>

                        <div className="test__answers">
                            {answers.map(([value, label]) => (
                                <button
                                    key={value}
                                    type="button"
                                    className={
                                        selected[i] === value
                                            ? 'test__answer test__answer--active'
                                            : 'test__answer'
                                    }
                                    onClick={() => {
                                        const next = [...selected];
                                        next[i] = value;
                                        setSelected(next);
                                    }}
                                >
                                    <span>{value}</span>
                                    <span>{label}</span>
                                </button>
                            ))}
                        </div>
                    </article>
                ))}
            </div>

            <button
                className="test__submit"
                type="button"
                disabled={answered !== test.questions.length}
                onClick={handleSubmit}
            >
                <span>
                    {testIndex === tests.length - 1
                        ? 'Завершить'
                        : 'Следующий тест'}
                </span>
                <span>→</span>
            </button>
        </section>
    );
}